<template>
  <v-dialog v-model="show" max-width="1200">
    <v-card>
      <v-card-title>Sky Model Recommendations</v-card-title>
      <v-data-table :headers="headers"
                    :items="items"
                    hide-default-footer
                    disable-sort
                    item-class="align-start"
      />
      <v-card-text class="text-caption">*Consider local development representation.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "dlgMethodHelp",
  data() {
    return {
      show: false,
      headers: [
        { text: 'Model Family', value: 'family' },
        { text: 'Data Required', value: 'data' },
        { text: 'Best For', value: 'best' },
        { text: 'Forecast Behavior', value: 'forecast' },
      ],
      items: [
        { family: 'Arps', data: 'Production history; Sky applies AI assistance to the DCA workflow.', best: 'A familiar DCA benchmark, for mature and stable production profiles, or outside Sky AI basin coverage (includes conventional).', forecast: 'Traditional decline-curve behavior. Best when enough representative production history exists.' },
        { family: 'Advanced*', data: 'Production history; basin-informed learning distinguishes it from a well-only DCA fit. Additional features optional.', best: 'Production is stable or a conservative forecast is preferred.', forecast: 'Smooth, stable and often conservative.' },
        { family: 'Multi*', data: 'Works with available inputs; additional completion features such as lateral length and measured depth improves stability and quality.', best: 'The well is early-life (about 1–36 months), or production history is short/noisy, or production to-date is on the higher side amongst peers in the area.', forecast: 'Responsive, with some fluctuations; generally more stable than Hyper.' },
        { family: 'Hyper*', data: 'Works with available inputs; additional completion features such as lateral length and measured depth improves stability and quality.', best: 'Wells have multi-phase production like condensate, or in sparse, fringe, or new-development areas.', forecast: 'Values 12-month accuracy over a smooth curve, so appears more granular. May spike up/down month to month to show response while preserving the broader trend.' },
      ]
    }
  },
  methods: {

  }
}
</script>
